export const buildMessage = (model, sites) => {
  let siteValue = findSiteName(model.Site, sites);
  let mealType = mealTypeOptions[model.MealType].label;
  let messages = {};

  messages.MealType = `Meal Type: ${mealType}`;
  messages.TotalParticipation = `Participation:  ${model.TotalParticipation}`;
  messages.ServingDate = `Serving Date: ${model.ServingDate}`;
  messages.Site = `Site: ${siteValue}`;
  if (Number(model.TotalParticipation) > model.siteStudents) {
    messages.SiteStudents =
      `Warning: Total Participation exceeds the ` +
      `${model.siteStudents} students at ${siteValue}.`;
  }
  return messages;
};

const findSiteName = (siteObj, sites) => {
  let site = sites.find(site => site.value === siteObj);
  return site.text;
};

let mealTypeOptions = [
  { value: 0, label: 'Breakfast' },
  { value: 1, label: 'Lunch' },
];



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/helpers/MessageBuilder.js